import { useEffect, useState } from "react";
import { useTranslation } from "src/hooks/useTranslation";
import { usePassportStore } from "src/stores/Passport.store";
import { eventDispatcher } from "src/helpers/eventEmitter";

export const usePaymentMethodsDrawerState = () => {
  const passportStore = usePassportStore();
  const { isCardPayment } = passportStore;
  const [showDetailServiceFeeDrawer, setShowDetailServiceFeeDrawer] = useState(
    false
  );
  const [showVirtualAccountDrawer, setShowVirtualAccountDrawer] = useState(
    false
  );

  const translate = useTranslation() as any;

  const detailServiceTranslate = (type: string) => {
    const paymentType = isCardPayment ? "card_payment" : "basic_package";
    return translate(
      `payment_methods.${paymentType}.detail_service_fee.modal.${type}`
    );
  };

  useEffect(() => {
    showDetailServiceFeeDrawer &&
      eventDispatcher.publish({
        action: isCardPayment ? "Ob_Fee_basic_cc" : "Ob_Fee_basic",
      });
    // eslint-disable-next-line
  }, [showDetailServiceFeeDrawer]);

  useEffect(() => {
    showVirtualAccountDrawer &&
      eventDispatcher.publish({ action: "Ob_VA_clicked" });
    // eslint-disable-next-line
  }, [showVirtualAccountDrawer]);

  return {
    showDetailServiceFeeDrawer,
    setShowDetailServiceFeeDrawer,
    showVirtualAccountDrawer,
    setShowVirtualAccountDrawer,
    detailServiceTranslate,
  };
};
